import { createGlobalStyle } from "styled-components";

// zaimportowane w App.js
const GlobalStyle = createGlobalStyle`
//! COLORS VARIABLES
:root{
  --primary: #efb6b2;
  --secondary: #4e4e4e;
  --error: #ff4a4a;
}

* {
  margin: 0;
  padding: 0;
  font-family: 'Noto Serif', serif;
  color: var(--secondary);
}
*,
*::before,
*::after {
  box-sizing: inherit;
}
html {
  box-sizing: border-box;
  font-size: 62.5%;
  /* 1rem = 10px, default font =  16/10 = 62.5 */
  @media only screen and (max-width: 501) {
    font-size: 50%;
    /* 1rem = 8 px (16/8 = 0.5) */
  }
}



`;

export default GlobalStyle;
